import { formStore } from '@/stores/form.js';

export function useInfoContent() {
  const infoPopup = (value) => {
    const form = formStore();
    let popupContent = { title: null, content: null };
    if (form.info && form.info.length > 0) {
      form.info.forEach((val) => {
        if (val['code'] === value) {
          popupContent = {
            title: val['title'],
            content: val['content'],
          };
        }
      });
    }
    return popupContent;
  };

  return { infoPopup };
}
